export const API_URL = window.tagwohnen.API_URL || 'https://immo.isp-10130-1.domservice.de/properties';
export const ASSET_HOST = window.tagwohnen.ASSET_HOST || 'http://localhost:3000';
export const exposeUrl = window.tagwohnen.EXPOSE_URL || '/immosuche/expose';
export const searchUrl = window.tagwohnen.SEARCH_URL || '/immosuche';
export const contactUrl = window.tagwohnen.CONTACT_URL || '/kontakt';
export const directContactUrl = window.tagwohnen.DIRECT_CONTACT_URL || '/direktkontakt';
export const contactFormHandler = '/mail-api';
export const contactFormUser = undefined;
export const contactFormPassword = undefined;
export const externalContactUrl = 'https://demo.wohnungshelden.de/public/listings/';
export const externalContactUrlApplicationPostfix = '/application?c=8881bf0e-376a-4ec1-9081-061852c8f776';
